<script setup>
import { ref, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ProfileCard from '@components/player/ProfileCard.vue'
import AchievementsTable from '@components/player/AchievementsTable.vue'
import Loading from '@components/global/Loading.vue'

const route = useRoute()
const router = useRouter()
const loading = ref(false)
const player = ref({})
const requestPlayer = ref(null)
const slug = computed(() => route.params.slug)

/* Composed from the payload: the copy stays here, the data comes from the api. */
const qualifications = computed(() =>
	(player.value.qualifications ?? []).map((qualification) => ({
		title: `Qualified for ${qualification.event}`,
		label: qualification.game,
	})),
)

const achievements = computed(() => player.value.achievements ?? [])

function cancelPlayer() {
	if (requestPlayer.value) requestPlayer.value.cancel()
}
function getPlayer() {
	loading.value = true
	player.value = {}
	cancelPlayer()
	let axiosSource = axios.CancelToken.source()
	requestPlayer.value = { cancel: axiosSource.cancel }
	axios
		.get(`/api/player/${route.params.slug}`, {
			cancelToken: axiosSource.token,
		})
		.then((a) => {
			loading.value = false
			player.value = a.data
		})
		.catch((e) => {
			if (e?.response?.status === 404) {
				router.push('/points-ranking')
			}
		})
}
getPlayer()

watch(slug, async () => {
	getPlayer()
})
</script>

<template>
	<Loading v-if="loading" />
	<main class="mt-24" v-else>
		<section class="my-10">
			<div class="container">
				<div class="grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-6">
					<div class="min-w-0 lg:order-2 lg:pt-10">
						<ProfileCard class="lg:sticky lg:top-28" :player="player" :qualifications="qualifications" />
					</div>
					<div class="flex min-w-0 flex-col gap-6 lg:order-1 lg:col-span-2" v-if="achievements.length">
						<div class="label text-sm">Achievements</div>
						<div class="flex flex-col gap-3">
							<AchievementsTable v-for="achievement in achievements" :key="achievement.slug" :title="achievement.game" :results="achievement.results" />
						</div>
					</div>
				</div>
			</div>
		</section>
	</main>
</template>
